import { TransportHistoryFilters } from "../../../redux/interfaces/transport.interface";
import { dateToString, parseDate } from "../../../utils/dateAndTime";

export const TRANSPORT_HISTORY_DATE_FORMAT = "DD-MM-YYYY";

export const getTransportHistoryFilters = (
  search?: Partial<
    Record<keyof TransportHistoryFilters, string | number>
  > | null,
): TransportHistoryFilters => ({
  ruta: search?.ruta === "" ? undefined : search?.ruta,
  masina: search?.masina?.toString() || undefined,
  sofer: search?.sofer?.toString() || undefined,
  data_start_de_la:
    dateToString(
      parseDate(
        search?.data_start_de_la?.toString(),
        TRANSPORT_HISTORY_DATE_FORMAT,
      ),
    ) || undefined,
  data_start_pana_la:
    dateToString(
      parseDate(
        search?.data_start_pana_la?.toString(),
        TRANSPORT_HISTORY_DATE_FORMAT,
      ),
    ) || undefined,
});
